<template>
    <div>
        <healthy-habits-predefined v-if="!$store.state.healthyHabits.isReadOnlyView && $store.state.healthyHabits.table.data.items && $store.state.healthyHabits.table.data.items.length === 0"></healthy-habits-predefined>
        <healthy-habits-table></healthy-habits-table>
    </div>
</template>

<script>
import healthyHabitsMixin from '@/mixins/healthyHabits.mixin'
import HealthyHabitsTable from '@/components/views/healthy-habits/HealthyHabitsTable'
import HealthyHabitsForm from '@/components/views/healthy-habits/HealthyHabitsForm'
import HealthyHabitsPredefined from '@/components/views/healthy-habits/HealthyHabitsPredefined'

export default {
   name: 'healthyHabits',
   components: {
    HealthyHabitsTable,
    HealthyHabitsForm,
    HealthyHabitsPredefined
   },
   mixins: [healthyHabitsMixin],
   created () {
    this.getHealthyHabitsData()
   },
   mounted () {
    if (this.isRouteFromClinicHistory()) {
        this.$store.state.healthyHabits.form.show = true
    }
    window.scrollTo(0, 0)
   },
   data () {
    return {
    }
   },
   methods: {
    backHealthyHabits () {
        location.href = this.$helpers.getV2AppUrl('patient')
    }
   }
}
</script>

<style lang="scss">

</style>


// WEBPACK FOOTER //
// src/components/views/healthy-habits/HealthyHabits.vue